export default "__VITE_ASSET__ec19f426__"